import React, { useState, useContext } from 'react'

interface Context {
  selectedSaleType: number
  setSelectedSaleType(value: number): void
}

const SaleTypeContext = React.createContext({} as Context)

export function useSaleTypeContext() {
  return useContext(SaleTypeContext)
}

export function SaleTypeContextProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [selectedSaleType, setSelectedSaleType] = useState(12)

  return (
    <SaleTypeContext.Provider value={{ selectedSaleType, setSelectedSaleType }}>
      {children}
    </SaleTypeContext.Provider>
  )
}
